module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_RaggedRight",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "italic",
      "font-size": "1.17em"
    }
  }, [_vm._v("Some guys have all the luck.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("“Chris?” Jase regarded him with amusement. “You got enough shots in this position? Only, I’m gonna get cramps in my legs any second now.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("“I’ll rub ’em for ya,” Gabe volunteered, slipping his hand under the sheets, but Jase stopped the motion with his own hand, grasping Gabe’s wrist firmly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("“That’s quite all right. I’m more than capable of doing that myself.” He glanced toward Chris with an eye roll that Gabe wouldn’t catch.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("Chris felt a little lighter. “Okay, guys, I think that’s enough. We’ve got plenty of the steamier poses in case the publisher wants to try and slip one past Amazon again.” "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("And good luck with that.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0